import * as menu from '@/store/modules/settings/menu.js'

export const namespaced = true

export const modules = {
  menu
}

export const state = {
}

export const getters = {
}

export const mutations = {
}

export const actions = {
  setPrimaryBG ({ commit }) {
    document.body.style.setProperty('background-color', '#FFFFFF')
  },
  setSecondaryBG ({ commit }) {
    document.body.style.setProperty('background-color', '#F0F4F8')
  },
  load ({ commit, dispatch }) {
    return dispatch('menu/loadMenuSettings')
  }
}
